import React from 'react'
import { AccordionProvider } from './AccordionProvider'
import AccordionContent from './AccordionContent'
import AccordionTrigger from './AccordionTrigger'

export interface IAccordion {
  open?: boolean
  shouldAnimate?: boolean
  shouldMapOpenPropToContent?: boolean
  children?: React.ReactNode
}

/** @public */
const Accordion = ({
  open = false,
  shouldAnimate = true,
  shouldMapOpenPropToContent = false,
  children,
}: IAccordion) => (
  <AccordionProvider
    open={open}
    shouldAnimate={shouldAnimate}
    shouldMapOpenPropToContent={shouldMapOpenPropToContent}
  >
    {children}
  </AccordionProvider>
)
Accordion.Trigger = AccordionTrigger
Accordion.Content = AccordionContent

export default Accordion
